import { useEffect, useState } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SPFormButton from '../../../components/SellerProfile/Form/SPFormButton';
import SPForm from '../../../components/SellerProfile/Form/SPForm';
import { ConfirmationFadeAlert } from '../../../components/SellerProfile/ConfirmationAlert/ConfirmationAlert';
import recipientForm from '../../../components/SellerProfile/Form/json/recipientFormFields.json';
import FilterNotificationRecipients from '../../../components/SellerProfile/FilterNotificationRecipients/FilterNotificationRecipients';
import './NotificationsRecipients.scss';
import { doFormErrorMsgs, getUserEmailList, isEmpty } from '../APIs/Helpers';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setFormLoading,setShowSuccessPopUp,setErrorMsg,setOnboardCompletePopupDetails,setModalType} from '../../../redux/slices/sellerProfileSlice';
import {
  fetchNotificationRecipentsStart,
  fetchNotificationTypesStart,
  addNotificationRecipientStart,
  resetSubmitSuccess
} from '../../../redux/slices/notificationSlice';

function NotificationsRecipients() {
  const dispatch = useDispatch();
  const [emailList, setEmailList] = useState(false);
  const [showAddRecipient, setShowAddRecipient] = useState<boolean>(false);
  const [loaded, setLoaded] = useState(false);
  const [clearForm, setClearForm] = useState({});
  const showAlert = false;
  const { onboardingStatus, seller_id,formUpdates } = useSelector(
    (state: any) => state.sellerProfile
  );
  const { t, i18n } = useTranslation();
  const { notificationRecipients, notificationTypes, loading, submitSuccess } =
    useSelector((state: any) => state.notification);
    const {formLoading,spPageText} = useSelector((state: any) => state.sellerProfile);

  const dividerStyle = {
    background: '#EFEFEF',
    marginBlock: '12px'
  };

  useEffect(() => {
    if (seller_id) {     
      setClearForm({});
      dispatch(fetchNotificationTypesStart());
      dispatch(fetchNotificationRecipentsStart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, seller_id]);

  useEffect(() => {
    if (notificationRecipients.length > 0) {
      const emailList: any = getUserEmailList(notificationRecipients);
      setEmailList(emailList);
      setLoaded(true);
    } else {
      doFormErrorMsgs(
        'error getting notification recipients',
        dispatch,
        spPageText
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationRecipients]);

  useEffect(() => {
    if (notificationTypes.length > 0) {
      const notification_type = `notification_type_${i18n.language}`;
      notificationTypes.forEach((notif) => {
        recipientForm.notifications.options[notif.notification_type_id][
          'label'
        ] = notif[notification_type];
      });
      setClearForm({ ...recipientForm });
    } else {
      doFormErrorMsgs(
        'error getting notification types',
        dispatch,
        spPageText
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationTypes, i18n.language]);

  useEffect(() => {
    if (submitSuccess) {
      const successMsg = t('sellerProfile.dashboard.newRecipAdded');
      dispatch(setShowSuccessPopUp(successMsg));
      if (!onboardingStatus.notification && onboardingStatus?.completed === 2) {
        dispatch(setOnboardCompletePopupDetails({
          show: true,
          navigate: false,
          close: true
        }));
      }
      setShowAddRecipient(false);
      dispatch(resetSubmitSuccess());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSuccess, onboardingStatus]);

  const submitFormFields = async (formName) => {
    const newNotifInfo = formUpdates[formName]?.inputFields?.options;
    const newNotifRecip = {
      user_email: newNotifInfo?.user_email?.content,
      user_first_name: newNotifInfo?.user_first_name?.content,
      user_last_name: newNotifInfo?.user_last_name?.content,
      notif_lang_pref: newNotifInfo?.preferred_language_type?.content || `en`
    };
    const getCheckedNotifs =
      formUpdates[formName]?.notifications?.options;
    const notifArray: any = [];
    Object.keys(getCheckedNotifs).forEach((notif) => {
      getCheckedNotifs[notif].checked && notifArray.push(notif);
    });
    newNotifRecip['notifications'] = notifArray;
    try {
      dispatch(addNotificationRecipientStart({ updates: newNotifRecip }));
      dispatch(setModalType(''));
    } catch (error: any) {
      const errMsg = error.err_code ? `error${error.err_code}` : 'errorGeneral';
      window.scrollTo({ top: 200, behavior: 'smooth' });
      dispatch(setShowSuccessPopUp({
        message: t('sellerProfile.dashboard.errorGeneral'),
        successType: 'error'
      }));
     dispatch(setErrorMsg(spPageText[errMsg]));
      console.log(
        'Error adding new Notif Recip:',
        error?.response?.data?.err_code
      );
    }
  };

  return loaded && !isEmpty(clearForm) ? (
    <Box className="addNewRecipientBox">
      <Divider sx={dividerStyle} />
      <Button
        variant="text"
        onClick={() => {
          setShowAddRecipient(!showAddRecipient);
          dispatch(setFormLoading(false));
        }}
        className="addNewRecipientBtn"
      >
        <Typography>{t('sellerProfile.dashboard.addNewRecipient')}</Typography>
        {showAddRecipient ? <ExpandLessIcon /> : <ExpandMoreIcon />}{' '}
      </Button>
      <Box>
        {showAddRecipient && (
          <form>
            <SPForm
              cols="single"
              compName="addRecipent"
              formFields={clearForm}
              formName="addNotificationRecip"
              key="addNotificationRecip"
              emailList={emailList}
            />
            <div className="addRecipientButton">
              {!formLoading && (
                <SPFormButton
                  label={t('sellerProfile.dashboard.addRecip')}
                  compName="addRecipent"
                  formName="addNotificationRecip"
                  handleClick={() => submitFormFields('addNotificationRecip')}
                  showLoading={loading}
                />
              )}
            </div>
          </form>
        )}
      </Box>
      <Divider sx={dividerStyle} />

      <FilterNotificationRecipients />

      {showAlert && (
        <ConfirmationFadeAlert
          message={t('sellerProfile.dashboard.newRecipAdded')}
          showAlert
        />
      )}
    </Box>
  ) : (
    <></>
  );
}

export default NotificationsRecipients;
